import { multiply } from 'mathjs';
import kaukolampo from "./formulas/kaukolampo";
import maalampo from "./formulas/maalampo";
import oljy from "./formulas/oljy";
import sahko from "./formulas/sahko";
import ilmavesi from "./formulas/ilmavesi";

export default {
  /**
   * returns kW
   *
   * @param buildingType okt,kt,toim,koulu,teol)
   * @param buildingYear 0,1,2 (<1990, 90-09, 10>)
   * @param buildingVolume
   */
  laskeTehonTarve(buildingType, buildingYear, buildingVolume) {
    const multipliers = {
      okt: [25, 22, 18],
      rt: [24, 20, 16],
      kt: [28, 22, 15],
      lr: [30, 25, 20],
      teol: [25, 20, 15],
      halli: [27, 22, 18],
      palv: [29, 23, 17],
      muu: [30, 25, 20],
    };

    const multiplier = multipliers[buildingType][buildingYear];
    return multiply(buildingVolume, multiplier, 0.001);
  },

  /**
   * returns kWh
   * @param buildingType
   * @param buildingYear
   * @param buildingVolume
   */
  laskeOminaiskulutus(buildingType, buildingYear, buildingVolume) {
    const multipliers = {
      okt: [60, 50, 40],
      rt: [55, 45, 35],
      kt: [55, 40, 30],
      lr: [50, 40, 30],
      teol: [45, 35, 25],
      halli: [25, 20, 15],
      palv: [55, 45, 35],
      muu: [50, 40, 30],
    };

    const multiplier = multipliers[buildingType][buildingYear];
    return multiply(buildingVolume, multiplier, 0.001);
  },

  laskeKaikki(sijainti, rakennustyyppi, teho, laskettuEnergiaKulutus, nykymuoto, nykykulutus, liittymisetaisyys) {
    let energiaKulutus = laskettuEnergiaKulutus;
    if (nykykulutus != null && Number.parseInt(nykykulutus) > 0) {
      if (nykymuoto === 'oljy') {
        energiaKulutus = oljy.energiaNykykulutuksesta(nykykulutus)
      } else if (nykymuoto === 'maalampo') {
        energiaKulutus = maalampo.energiaNykykulutuksesta(nykykulutus)
      } else if (nykymuoto === 'ilmavesi') {
        energiaKulutus = ilmavesi.energiaNykykulutuksesta(nykykulutus)
      } else if (nykymuoto === 'sahko') {
        energiaKulutus = sahko.energiaNykykulutuksesta(nykykulutus);
      }
    }

    const kl = kaukolampo.laske(sijainti, rakennustyyppi, teho, energiaKulutus, liittymisetaisyys);

    // muut
    const ml = maalampo.laske(sijainti, rakennustyyppi, teho, energiaKulutus);
    const ol = oljy.laske(sijainti, rakennustyyppi, teho, energiaKulutus);
    const sah = sahko.laske(sijainti, rakennustyyppi, teho, energiaKulutus);
    const iv = ilmavesi.laske(sijainti, rakennustyyppi, teho, energiaKulutus);

    return {
      kaukolampo: kl,
      maalampo: ml,
      oljy: ol,
      sahko: sah,
      ilmavesi: iv,
    }
  },
};
